export const user = {
  id: 'ucware',
  pwd: 'ucware1234',
  key: 'dfdsfgwhjbvasdhvjgkaerihfsadarewfwjkegtf743659843ruiftviy43289rby7tfqrwetgv1564786541g56475t86gwefjwe4gryi25r4f4d6541321',
};
